import { t } from 'i18next';

export default function EmptyExploreTradingPhotoCard() {
  return (
    <div className="flex flex-col items-center mt-[88px] mb-[96px] gap-1">
      <span className="text-[50px]">🙄</span>
      <p className="text-main-light-2 dark:text-main-dark-2 font-bold text-[17px] leading-[22px] break-keep">
        {t('emptyExploreTradingPhotoCard.title')}
      </p>
      <p className="text-main-light-4 dark:text-main-dark-4 font-medium text-[14px] leading-[17px]">
        {t('emptyExploreTradingPhotoCard.description')}
      </p>
    </div>
  );
}
